// /**
//  * Testimonial Carousel
//  */

import '../../../node_modules/owl.carousel/dist/owl.carousel.min.js';

import $ from 'jquery';

const testimonialCarousel = {
  initTestimonialCarousel: () => {
    $('.testimonial-owl-carousel').each(function () {
      $(this).owlCarousel({
        smartSpeed: 800,
        direction: 'next',
        slideTransition: 'linear',
        loop: false,
        slideBy: 'page',
        items: 1,
        margin: 300,
        stagePadding: 0,
        nav: true,
        dots: true,
        dotsEach: 1,
        autoWidth: false,
        lazyload: false,
        center: false,
        navText: [
          $(this).next().find('.carousel-control-prev-icon'),
          $(this).next().find('.carousel-control-next-icon'),
        ],
        responsive: {
          1820 : {
            margin: 900,
            autoWidth: true,
          }
        },

        onInitialized() {
          $(this).find('.owl-item').attr('aria-current', 'false');
          $(this).find('.owl-item.active').attr('aria-current', 'true');
          // Add aria attribute to dots
          $(this)
            .find('.owl-dot')
            .each(function (index) {
              //Add one to index so it starts from 1
              $(this).attr('aria-label', `slide ${index + 1}`);
            });
          $(this).attr('tabindex', '0');
          // Add aria attributes to buttons
          $(this)[0].$element.find('.owl-prev').attr('aria-label', 'previous');
          $(this)[0].$element.find('.owl-prev').attr('role', 'button');
          $(this)[0].$element.find('.owl-next').attr('aria-label', 'next');
          $(this)[0].$element.find('.owl-next').attr('role', 'button');

          // Remove controls if only 1 testimonial
          const nav = $(this)[0].$element.find('.owl-nav');
          const dots = $(this)[0].$element.find('.owl-dots');
          const items = $(this)[0].$element.find('.owl-item');

          if (items.length === 1) {
            nav.addClass('hide-controls');
            dots.addClass('hide-controls');
          }

          if (this._current === 0) {
            $(this)[0].$element.find('.owl-prev').prop('disabled', true);
          }
        },
        onTranslated() {
          if (this._current === this._items.length - 1) {
            $(this)[0].$element.find('.owl-next').prop('disabled', true);
          } else {
            $(this)[0].$element.find('.owl-next').prop('disabled', false);
          }

          if (this._current === 0) {
            $(this)[0].$element.find('.owl-prev').prop('disabled', true);
          } else {
            $(this)[0].$element.find('.owl-prev').prop('disabled', false);
          }
        },
      });
    });
  },
};

export default testimonialCarousel;
